import takoColors from '../theme/colors';

/**
 * Calculates the luminance of the color and returns appropriate font color (either N900 or N0)
 * If the luminance is greater than 0.5, it returns N900; otherwise, it returns N0.
 * @param hex - Hex color string (e.g. "#ffffff")
 * @returns "#ffffff" | "#1e0d35"
 */
export const getContrastColor = (hex: string) => {
    if (!hex) {
        return takoColors.N900;
    }
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 2), 16);
    const b = parseInt(hex.substring(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? takoColors.N900 : takoColors.N0;
};
